module.exports = __webpack_public_path__ + "img/plate01_03.37feab6e.png";